import { useEffect, useState } from "react";
import styles from "./search-block.module.less";
import { onSearchChange } from "../../layout/header/header";
import Search from "../../elements/search-components/search/search";
import { useSearchQuery } from "../../../react-query-queries/use-search-query";
import { useDebounce } from "../../../hooks/useDebounce";
import { shouldShowSearchLoader } from "../../../helpers/search-helper";

export type TSearchBlockProps = {
  searchTermFromParams?: string;
  currentLanguage: string;
  siteId: string;
  onSearchChange?: onSearchChange;
};

export const SearchBlock = ({ searchTermFromParams, currentLanguage, siteId, onSearchChange }: TSearchBlockProps) => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const debouncedSearchTerm = useDebounce(searchTerm);

  useEffect(() => {
    setSearchTerm(searchTermFromParams ?? "");
  }, [searchTermFromParams]);

  const {
    data: searchResults,
    isLoading: isLoadingPostSearchTerm,
    error,
  } = useSearchQuery(debouncedSearchTerm, currentLanguage, siteId);

  const isLoading = shouldShowSearchLoader(isLoadingPostSearchTerm, searchTerm, debouncedSearchTerm);

  const onChangeSeachTerm = (searchTerm: string) => {
    typeof onSearchChange === "function" && onSearchChange(searchTerm, true);
    setSearchTerm(searchTerm);
  };

  return (
    <section className={styles.wrapper}>
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        <Search
          isOpen={true}
          isLoadingSearchResults={isLoading}
          results={searchResults}
          searchTerm={searchTerm}
          hasError={error ? true : false}
          onChangeSearchTerm={onChangeSeachTerm}
        />
      </div>
    </section>
  );
};

export default SearchBlock;
